import React, {useMemo} from 'react';

import classNames from 'classnames';
import {t} from 'i18next';

import {weightedFreshPhase3Enabled} from 'constants/recommendation';
import {formatPrice, getCurrencySymbol} from 'utils';

import {StyledWeightedFreshText} from './styles';
import {WeightedFreshPriceProps} from './types';

export const WeightedFreshPriceComponent: React.FC<WeightedFreshPriceProps> = ({
  moq = 1,
  displayPrice,
  className,
  productCount = 0,
  isSellInPiece
}: WeightedFreshPriceProps): JSX.Element | null => {
  const productPrice = formatPrice(displayPrice / (moq || 1));
  const currencySymbol = getCurrencySymbol();

  const totalEstimate = useMemo(() => {
    return parseFloat(productPrice) * (productCount * moq);
  }, [productPrice, productCount, moq]);
  return (
    <StyledWeightedFreshText className={classNames({[className as string]: true, phase3: weightedFreshPhase3Enabled})}>
      {productCount === 0 ? (
        className === 'searchList' || className === 'searchListCarousel' ? (
          t('labels.minimumOrderSearchKg', {count: moq})
        ) : (
          t('labels.minimumOrderKg', {count: moq})
        )
      ) : (
        <>
          {t('labels.totalEstimate', {totalEstimate: formatPrice(totalEstimate), currencySymbol})}
          {isSellInPiece && productCount > 0 && (
            <>
              , {t('product:weightedFresh.unitWithCount', {count: productCount})}({t('product:weightedFresh.estimate')})
            </>
          )}
        </>
      )}
    </StyledWeightedFreshText>
  );
};
